module.exports = __webpack_public_path__ + "img/411.177b6ef7.jpg";